const ValphaLogo = "/valpha-logo.svg";

export default ValphaLogo;